import React from 'react';
import './pagetitle.css';

const PageTitle = ({ pageTitle }) => {
  return (

    <h1>{pageTitle}</h1>
  )
}

export default PageTitle

